import { Injectable } from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class ModalCloserService {

  closeEvents = new Subject();

  constructor() { }

}



// WEBPACK FOOTER //
// /app/src/app/modal-closer.service.ts